import { StateCreator } from 'zustand';

export interface Twin {
  id?: string;
  personalityId?: string;
  personalityName: string;
  profession?: string;
  description?: string;
  avatar?: string;
  source?: 'url' | 'list';
  url?: string; 
  [key: string]: unknown;
}

export interface SelectedTwinSlice {
  selectedTwins: Twin[];
  setSelectedTwins: (twins: Twin[]) => void;
  addTwin: (twin: Twin) => void;
  removeTwin: (index: number) => void;
  removeTwinByName: (personalityName: string) => void;
  clearSelectedTwins: () => void;
  isAlreadySelected: (personalityName: string) => boolean;
  canAddMoreTwins: () => boolean;
  isUrlAlreadyUsed: (url: string) => boolean;
}

export const selectedTwinSlice: StateCreator<SelectedTwinSlice> = (set, get) => ({
  selectedTwins: [],
  
  setSelectedTwins: (twins: Twin[]) => 
    set(() => ({ selectedTwins: twins })),
  
  addTwin: (twin: Twin) => 
    set((state) => {
      const isAlreadySelected = state.selectedTwins.some(
        (t) => t.personalityName === twin.personalityName
      );
      
      if (!isAlreadySelected && state.selectedTwins.length < 2) {
        return { selectedTwins: [...state.selectedTwins, twin] };
      }
      
      return state;
    }),
  
  removeTwin: (index: number) => 
    set((state) => ({
      selectedTwins: state.selectedTwins.filter((_, i) => i !== index)
    })),
  
  removeTwinByName: (personalityName: string) => 
    set((state) => ({
      selectedTwins: state.selectedTwins.filter(
        (twin) => twin.personalityName !== personalityName
      )
    })),
  
  clearSelectedTwins: () => 
    set(() => ({ selectedTwins: [] })),
  
  isAlreadySelected: (personalityName: string) => {
    const state = get();
    return state.selectedTwins.some(
      (twin) => twin.personalityName === personalityName
    );
  },
  
  canAddMoreTwins: () => {
    const state = get();
    return state.selectedTwins.length < 2;
  },

  // Add a function to check if a URL is already used
  isUrlAlreadyUsed: (url: string) => {
    const state = get();
    return state.selectedTwins.some((twin) => twin.url === url);
  },
});